import React from 'react';
import { object, bool } from 'prop-types';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import GigCardCarouselWrapper from '../shared/GigCardCarouselWrapper';
import { BOTTOM } from '../shared/GigCardCarouselWrapper/config';
import SafePureComponent from '../shared/SafePureComponent';
import { RECOMMENDED_IN_SUBCATEGORY, CAROUSEL_CONTEXT } from '../../utils/carousels';

export const SOURCE = 'recommended_in_sc';
export const PRO_SOURCE = 'recommended_in_pro_sc';

const RecommendedInSc = ({
    isTouch,
    isLoggedIn,
    shouldFetchCarousel = true
}, {
    general,
    pathfinderWrapper
}) => {

    const getSource = () => general.isPro ? PRO_SOURCE : SOURCE;

    const { gigId, isPro } = general;
    const { queryParameters } = getContext();
    const { ref } = queryParameters;

    const url = pathfinderWrapper.pathfinder('gig_page_fetch_recommendations_by_type',
        { type: 'by_gig_views' },
        { query: { gig_id: gigId, pro_only: isPro.toString(), ref } });

    return (
        <GigCardCarouselWrapper boxTitle={<I18n k="gig_page_perseus.recommended_gigs.people_also_viewed.title"/>}
            boxClass="gigs-recommended-in"
            boxLocation={BOTTOM}
            type={RECOMMENDED_IN_SUBCATEGORY}
            url={url}
            carouselPosition={4}
            isLoggedIn={isLoggedIn}
            isTouch={isTouch}
            source={getSource()}
            carouselContext={CAROUSEL_CONTEXT}
            shouldFetchCarousel={shouldFetchCarousel}/>
    );
};

RecommendedInSc.propTypes = {
    isTouch: bool,
    isLoggedIn: bool,
    shouldFetchCarousel: bool
};

RecommendedInSc.contextTypes = {
    general: object,
    pathfinderWrapper: object
};

export { RecommendedInSc };
export default SafePureComponent(RecommendedInSc);
